export enum OrgTypes {
    PART145 = 'PART145',
    PART91 = 'PART91',
}

export enum OrgSubtypes {
    FREE = 'FREE',
    SOLO = 'SOLO',
    MULTI = 'MULTI',
}